import { AnyDocument } from '../../../types';

export const buildDocumentChannelName = (
  documentId: AnyDocument['id'],
): string => `documents.${documentId}`;
